import createEvaluationsHook from './createEvaluationsHook';

export default createEvaluationsHook('evaluationEventEducator', 'event');
